import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';

import { withinBettingContext } from 'app/contexts/betting';
import { ModulesScrollbarContext } from 'app/design-system/components/Scrollbar';
import { MatchType } from 'app/lib/betting/betting-entities';

import { MatchRowStatus } from '../../../constants';
import MatchDetails from '../../MatchDetails';
import InnerLineContainer from './InnerLines';
import MatchLineButtons from './MatchLineButtons';
import RightCellDefault from './RightCellDefault';
import RightCellHeadToHead from './RightCellHeadToHead';

import styles from './MatchRow.module.scss';

// ---

const RIGHT_CELLS_BY_MATCH_TYPE = {
  [MatchType.HEAD_TO_HEAD]: RightCellHeadToHead,
};

class MatchRow extends Component {
  // TODO: typescript please
  // static propTypes = {
  //   matchId: PropTypes.number.isRequired,
  // };

  static contextType = ModulesScrollbarContext;

  constructor(props) {
    super(props);
    this.state = {
      expansion: MatchRowStatus.COLLAPSED,
      scrollTopByMatchId: new Map(),
    };
  }

  handleExpandClick = (event) => {
    event.preventDefault();

    const { fetchFullMatchContent } = this.props.$betting.grid.actions;

    const { matchId } = this.props;

    const scrollRef = this.context.scrollbarRef;
    const contentWrapperEl = scrollRef?.current?.contentWrapperEl;

    if (contentWrapperEl) {
      const { scrollTop } = contentWrapperEl;

      if (this.state.expansion === MatchRowStatus.COLLAPSED) {
        this.setState((state) => ({
          scrollTopByMatchId: state.scrollTopByMatchId.set(matchId, scrollTop),
        }));
      }
      else {
        this.setState((state) => {
          contentWrapperEl.scrollTo({ top: state.scrollTopByMatchId.get(matchId) });
          return {
            ...state,
            scrollTopByMatchId: new Map(),
          };
        });
      }
    }

    if (typeof fetchFullMatchContent === 'function') {
      if (this.state.expansion === MatchRowStatus.COLLAPSED) {
        this.setState({
          expansion: MatchRowStatus.LOADING,
        });

        this.props.dispatch(fetchFullMatchContent(this.props.matchId))
          .then(() => {
            this.setState({
              expansion: MatchRowStatus.EXPANDED,
            });
          })
          .catch((err) => {
            // TODO: handle errors in user-friendly way
            console.error('match inner lines content fetching failed', err);

            this.setState({
              expansion: MatchRowStatus.COLLAPSED,
            });
          });
      }
      else if (this.state.expansion === MatchRowStatus.EXPANDED) {
        this.setState({
          expansion: MatchRowStatus.COLLAPSED,
        });
      }

      return;
    }

    this.setState(({ expansion }) => ({
      expansion: (expansion === MatchRowStatus.COLLAPSED)
        ? MatchRowStatus.EXPANDED
        : MatchRowStatus.COLLAPSED,
    }));
  };

  shouldComponentUpdate(nextProps, nextState) {
    return this.state !== nextState
      || this.props.betCount !== nextProps.betCount; // changed inner bets count
  }

  componentDidUpdate(prevProps) {
    const { betCount } = this.props;

    if (prevProps.betCount !== betCount && betCount === 0) {
      // ToDo Если всё ещё используется - переписать
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ expansion: MatchRowStatus.COLLAPSED });
    }
  }

  render() {
    const { expansion } = this.state;
    const { betCount, matchId, matchType } = this.props;

    const RightCell = RIGHT_CELLS_BY_MATCH_TYPE[matchType];
    const expanded = expansion === MatchRowStatus.EXPANDED;

    return (
      <div className={styles.matchRowContent}>
        <div className={styles.matchRow}
             data-test={`match-row-${matchId}`}>
          <div className={styles.detailsCell}>
            <MatchDetails matchId={matchId} />
          </div>

          {RightCell ? (
            <RightCell matchId={matchId}
                       betCount={betCount}
                       onClick={this.handleExpandClick} />
          ) : (
            <div data-test="match-row-default-header-title">
              <RightCellDefault expanded={expanded}
                                isHeadToHead={matchType === MatchType.HEAD_TO_HEAD} />
            </div>
          )}

          {Boolean(betCount) && (
            <MatchLineButtons matchId={matchId}
                              betCount={betCount}
                              matchType={matchType}
                              expansionState={expansion}
                              onClick={this.handleExpandClick} />
          )}
        </div>
        <div data-test={`inner-line-container-${matchId}`}
             className={styles.innerLineContainer}>
          {expanded && (
            <InnerLineContainer matchId={matchId} />
          )}
        </div>
      </div>
    );
  }
}

const createMapStateToProps = (state, {
  $betting: {
    content: {
      selectors: {
        matches,
      },
    },
  },
  matchId,
}) => {
  const matchesState = matches(state);
  const match = matchesState.get(matchId);
  const matchType = matchesState.getIn([matchId, 'type'], MatchType.HEAD_TO_HEAD);

  return ({
    betCount: match?.betsCount || 0,
    matchType,
  });
};

export default compose(
  withinBettingContext,
  connect(createMapStateToProps),
)(MatchRow);
